import {Component, Input} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss', '../../sign-up.component.scss']
})
export class UserPasswordComponent {

  @Input() userPasswordForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(null, [Validators.required, Validators.email]),
    password: new UntypedFormControl(null, [Validators.required, Validators.minLength(8)]),
    acceptTermsAndConditions: new UntypedFormControl(false, [Validators.required, Validators.requiredTrue])
  });

  @Input() isLoading?: boolean | null = false;

}
